import { fork } from 'redux-saga/effects';
import paymentSaga from './Payment';

const sagas = [paymentSaga];

export default function* rootSaga() {
  yield sagas.map(saga => fork(saga));
}
